// extracted by mini-css-extract-plugin
export default {"login-error":"errorPage_login-error__q0+nj"};